import { ZONE_MAPSTYLE } from '@popety_io/popety-io-lib'

export { default } from './EstimateLandSummary'

export const EstimateLandSummaryMapConfig = { style: ZONE_MAPSTYLE }
